import React from 'react';
import { Col, DatePicker } from 'antd';
import { I18n } from '@aws-amplify/core';

import { FormItem } from '@/components/ui/Inputs/FormItem';
import { InputDefaultProps } from '../../../types';

export function CollectionDate({ fieldName, isRequired = false }: Readonly<InputDefaultProps>) {
	return (
		<Col xs={24}>
			<FormItem
				fontSize="1rem"
				title={I18n.get('Collection date')}
				isRequired={isRequired}
				namePath={[fieldName, 'collection_date']}
				errorMessage={I18n.get('Enter the collection date')}
			>
				<DatePicker
					allowClear
					format="L"
					size="large"
					style={{ width: '100%' }}
					disabledDate={(current) => current && current.valueOf() >= Date.now()}
				/>
			</FormItem>
		</Col>
	);
}
